import React, { useEffect, useState, useMemo } from 'react';

import { Page } from '@vlabs/monokit/shared/ui/page';
import { connect } from 'react-redux';

import { fetchAnalyticStreams } from '@vlabs/pages/video-analytics/store';
import { selectIsAppFeatureAvailable } from '@vlapps/point/src/app/store/selectors';

import { EventRoll } from './event-roll/EventRoll.js';
import type { SidebarName } from './event-roll/EventRoll.js';
import { WorkspaceFiltersProvider } from './filters/useWorkspaceFilters';
import { getDefaultWorkspaceFilters } from './filters/workspaceFiltersModel';
import { SelectedEventView } from './selected-event/SelectedEventView';
import {
  selectLatestEventsFilters,
} from './selectors.js';
import {
  fetchLatestEvents,
  setViewedNotifyIds,
} from './store.js';
import st from './Workspace.module.sass';
import { WorkspaceEventProvider } from './WorkspaceEventContext';

function WorkspaceComponent({
  getLatestEvents,
  latestFilters,
  isVideoAnalyticsAvailable,
  isAppFeaturesLoaded,
  getAnalyticStreams,
}): React.JSX.Element {
  const [activeSidebar, setActiveSidebar] = useState<SidebarName | null>(null);

  const defaultFilters = useMemo(() => getDefaultWorkspaceFilters({
    isVideoAnalyticsAvailable,
    savedFilters: latestFilters,
  }), [isVideoAnalyticsAvailable, latestFilters]);

  useEffect(() => {
    (async () => {
      if (!isAppFeaturesLoaded) return;

      if (isVideoAnalyticsAvailable) {
        getAnalyticStreams();
      }

      getLatestEvents();
    })();
    /* eslint-disable react-hooks/exhaustive-deps */
  }, [isAppFeaturesLoaded]);

  const toggleSidebar = (name: SidebarName) => {
    setActiveSidebar((prev) => (prev === name ? null : name));
  };
  return (
    <WorkspaceEventProvider>
      <WorkspaceFiltersProvider initialData={defaultFilters}>
        <Page className={st.Root}>
          <EventRoll
            activeSidebar={activeSidebar}
            onToggleSidebar={toggleSidebar}
          />

          <SelectedEventView
            activeSidebar={activeSidebar}
            onToggleSidebar={toggleSidebar}
          />
        </Page>
      </WorkspaceFiltersProvider>
    </WorkspaceEventProvider>
  );
}

export const Workspace = connect(
  (state) => ({
    latestFilters: selectLatestEventsFilters(state),
    isVideoAnalyticsAvailable: selectIsAppFeatureAvailable(state, 'components.video_analytics'),
    isAppFeaturesLoaded: selectIsAppFeatureAvailable(state, 'state'),
  }),
  (dispatch) => ({
    getLatestEvents: () => dispatch(fetchLatestEvents),
    getAnalyticStreams: () => dispatch(fetchAnalyticStreams),
    setViewedNotify: (id) => dispatch(setViewedNotifyIds({ id })),
  }),
)(WorkspaceComponent);
